<template>
    <div class="wx-container wx-container-flex">
        <div class="scroll-container scroll-container-tab">
            <div class="scroll-content">
                <div v-for="item in list" :key="item.id">
                    <demand-list-item :demand="item"></demand-list-item>
                </div>

                <div class="empty-notification" v-if="!searching && list.length <= 0">
                    <div class="empty-notification__text disable">暂无需求</div>
                </div>
            </div>
        </div>

        <div class="footer-operation">
            <div class="operation-container">
                <div class="operation-container__btn" @click="more">
                    发布新需求
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { viewDemandList } from '@/interface/modules/demand.api'
    import DemandListItem from '@/components/Demand/list-item'

    export default {
        components: {
            DemandListItem
        },
        data () {
            return {
                searching: false,
                list: [],
                filters: {
                    all: 1
                }
            }
        },
        methods: {
            init () {
                this.searching = true
                const that = this
                viewDemandList({
                    data: this.filters,
                    success: res => {
                        that.list = Object.assign([], res.items)
                        that.searching = false
                    }
                })
            },
            more () {
                this.$router.push({name: 'demandSeek'})
            }
        },
        mounted () {
            this.init()
        }
    }
</script>

